
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoActivePlan = () => {
  const { t } = useTranslation();

  return (
    <div className="fullscreen" style={{ backgroundColor: '#000', color: '#fff' }}>
      <div style={{ textAlign: 'center' }}>
        <h2>{t('noActivePlan.noActivePlan')}</h2>
        <img
          src="/yyslogo512.png"
          alt="YYS Logo"
          style={{ maxWidth: '300px', marginTop: '20px' }}
          draggable={false}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>
    </div>
  );
};

export default NoActivePlan;
